import { Agent, BookingAgent } from '@sales-app/types/Agent'
import { gql } from 'graphql-request'

export namespace AgentQueries {
  export namespace GET_AGENT {
    export type Response = { agent: Agent | null }
  }

  export namespace GET_SEARCH_AGENT {
    export type Response = { agents: BookingAgent[] | null }
  }

  export namespace GET_AGENTS {
    export type Response = { agents: Agent[] | null }
  }

  export namespace GET_SEARCH_SUPERVISOR {
    export type Response = { agents: Agent[] | null }
  }

  export function getAgents() {
    return gql`
      query getAgents {
        agents(sortBy: { field: CreatedAt, direction: Descending }) {
          id
          dialpadUserId
          userId
          name
          role
          currentStatus
          managerUserId
          supervisor {
            id
            userId
            name
          }
          lastStatusChange
          standard
          corporateHousing
        }
      }
    `
  }

  export function getAgentDetails() {
    return gql`
      query getAgentDetails($id: Int!) {
        agent(id: $id) {
          currentStatus
          dialpadUserId
          id
          name
          standard
          corporateHousing
        }
      }
    `
  }

  export function getSearchAgent() {
    return gql`
      query getSearchAgent($searchString: String) {
        agents(filter: { limit: 20, name: $searchString }) {
          name
          id
        }
      }
    `
  }

  export function getSearchSupervisor() {
    return gql`
      query getSearchAgent($searchString: String) {
        agents(filter: { limit: 20, name: $searchString }) {
          name
          id
          userId
        }
      }
    `
  }
}
